import React, { useEffect, useState } from 'react';
import { Cutlery, Notes, User, Star, Flash, Menu, ViewGrid, Home } from 'iconoir-react';
import { Play, Star as StarIcon } from 'lucide-react';
import { useCarrinho } from '../services/CarrinhoContext';
import { getComandasCliente } from '../services/api';
import './NavigationMenu.css';

function NavigationMenu({ onMenuClick, usuario, activeMenu = 'cardapio', hasHighlights = false, hasBanners = false, lojaLogoUrl, loja, isTabletMode = false, hasVideos = false }) {
  const { comandaExistente, ultimaComanda, brand } = useCarrinho();
  const [pedidosPendentes, setPedidosPendentes] = useState(0);
  const isMobile = window.innerWidth <= 768;
  
  const getNomeUsuario = () => {
    if (!usuario) return 'PERFIL';
    if (!usuario.nome || usuario.nome === null) return 'CLIENTE';
    return usuario.nome.split(' ')[0].toUpperCase();
  };
  
  const temPedidos = comandaExistente || ultimaComanda || usuario;

  useEffect(() => {
    if (!usuario) {
      setPedidosPendentes(0);
      return;
    }

    const buscarPedidosPendentes = async () => {
      const token = localStorage.getItem('sitri_token');
      if (!token) return;

      try {
        const result = await getComandasCliente(brand, token);
        if (result?.success) {
          const pendentes = result.comandas.filter(cmd => {
            const status = (cmd.status || '').toLowerCase();
            return status !== 'fechada' && status !== 'cancelada' && status !== 'entregue';
          }).length;
          setPedidosPendentes(pendentes);
        }
      } catch (error) {
        // Silencioso
      }
    };

    buscarPedidosPendentes();
    const interval = setInterval(buscarPedidosPendentes, 5000);
    return () => clearInterval(interval);
  }, [usuario, brand]);

  const handleClick = (action, event) => {
    event.stopPropagation();
    event.preventDefault();
    onMenuClick(action);
  };

  return (
    <div className={`navigation-menu ${isMobile ? 'mobile-nav' : ''}`}>
      {!isTabletMode && (
        <button 
          className={`nav-item ${activeMenu === 'loja' ? 'active' : ''}`} 
          onClick={(e) => handleClick('loja', e)} 
          type="button"
        >
          <ViewGrid />
          <span className="nav-label">INICIO</span>
        </button>
      )}
      {hasHighlights && false && (
        <button 
          className={`nav-item ${activeMenu === 'destaques' ? 'active' : ''}`} 
          onClick={(e) => handleClick('destaques', e)} 
          type="button"
        >
          <Star />
          <span className="nav-label">DESTAQUES</span>
        </button>
      )}
      {hasBanners && (
        <button 
          className={`nav-item ${activeMenu === 'promocoes' ? 'active' : ''}`} 
          onClick={(e) => handleClick('promocoes', e)} 
          type="button"
        >
          <StarIcon size={24} />
          <span className="nav-label">PROMOÇÕES</span>
        </button>
      )}
      <button 
        className={`nav-item ${activeMenu === 'cardapio' ? 'active' : ''}`} 
        onClick={(e) => handleClick('cardapio', e)} 
        type="button"
      >
        <Cutlery />
        <span className="nav-label">CARDÁPIO</span>
      </button>
      {hasVideos && (
        <button 
          className={`nav-item ${activeMenu === 'videos' ? 'active' : ''}`} 
          onClick={(e) => handleClick('videos', e)} 
          type="button"
        >
          <Play size={24} />
          <span className="nav-label">CLIPS</span>
        </button>
      )}
      {temPedidos && (
        <button 
          className={`nav-item ${activeMenu === 'meusPedidos' ? 'active' : ''}`} 
          onClick={(e) => handleClick('meusPedidos', e)} 
          type="button"
        >
          <Notes />
          {pedidosPendentes > 0 && (
            <span className="badge">{pedidosPendentes}</span>
          )}
          <span className="nav-label">PEDIDOS</span>
        </button>
      )}
      {!isTabletMode && (
        <button 
          className={`nav-item ${activeMenu === 'perfil' ? 'active' : ''}`} 
          onClick={(e) => handleClick('perfil', e)} 
          type="button"
        >
          <User />
          {usuario?.google_id && (
            <img 
              src="https://grubicons.s3.us-east-1.amazonaws.com/google-icon.avif"
              alt="Google"
              style={{
                position: 'absolute',
                bottom: '-2px',
                right: '-2px',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                border: '1px solid white',
                backgroundColor: 'white'
              }}
            />
          )}
          <span className="nav-label">{getNomeUsuario()}</span>
        </button>
      )}
    </div>
  );
}

export default NavigationMenu;
